import { Container } from 'unstated';
import Api from '../modules/api';
import { NotificacaoDados, FiltroNotificacoes } from '../modules/types';
import {
  getDataInicioDiasAtras,
  converterDataParaTimezoneBrasil
} from '../modules/utils';

export interface NotificacoesState {
  notificacoes: Array<NotificacaoDados>;
  erro: string;
  erroConexao: boolean;
  onTentarNovamente: (() => void) | null;
}

export class NotificacoesContainer extends Container<NotificacoesState> {
  state: NotificacoesState = {
    notificacoes: [],
    erro: '',
    erroConexao: false,
    onTentarNovamente: null
  };

  loadUltimosTrintaDiasNotificacoesAsync = async () => {
    const api = new Api();

    const filtros: FiltroNotificacoes = {
      dataInicio: converterDataParaTimezoneBrasil(getDataInicioDiasAtras(30)),
      dataFinal: converterDataParaTimezoneBrasil(new Date())
    };

    await api.getNotificacoes(
      {
        onSuccess: (notificacoes: Array<NotificacaoDados>) => {
          this.setState({
            notificacoes
          });
        }
      },
      filtros
    );
  };

  loadNotificacoesAsync = async (filtros: FiltroNotificacoes) => {
    const api = new Api();

    await api.getNotificacoes(
      {
        onSuccess: (notificacoes: Array<NotificacaoDados>) => {
          this.setState({
            notificacoes
          });
        },
        onError: (err: Error) => {
          this.setState({
            erro: err.message,
            erroConexao: err.name === 'TimeoutError',
            onTentarNovamente: () => this.loadNotificacoesAsync(filtros)
          });
        }
      },
      filtros
    );
  };

  marcarNotificacaoVisualizadaAsync = async (
    notificacaoId: number,
    visualizada: boolean,
    onSuccess: () => void
  ) => {
    const api = new Api();

    await api.postMarcarNotificacaoVisualizada(notificacaoId, visualizada, {
      onSuccess: async () => {
        if (onSuccess) {
          onSuccess();
        }
      },
      onError: (err: Error) => {
        this.setState({
          erro: err.message,
          erroConexao: err.name === 'TimeoutError',
          onTentarNovamente: () =>
            this.marcarNotificacaoVisualizadaAsync(
              notificacaoId,
              visualizada,
              onSuccess
            )
        });
      }
    });
  };

  retornarQuantidadeNotificacoesNaoVisualizadas = () => {
    return this.state.notificacoes.filter(x => !x.visualizada).length;
  };

  limparErro = () => {
    this.setState({
      erro: '',
      erroConexao: false,
      onTentarNovamente: null
    });
  };
}

export default new NotificacoesContainer();
